module.exports = __webpack_public_path__ + "static/media/refresh.567df026.png";